import defaultTheme from 'tailwindcss/defaultTheme'
import { ThemeConfig } from 'tailwindcss/types/config'

const fontFamily = {
  sans: ['var(--font-articulat)', ...defaultTheme.fontFamily.sans]
} satisfies ThemeConfig['fontFamily']

export { fontFamily }
